import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { style: {"margin-top":"8px"} }
const _hoisted_3 = ["alt", "src"]
const _hoisted_4 = ["src"]

import {onMounted, reactive, watch} from "vue";
import {message, UploadFile, UploadProps} from "ant-design-vue";
import {PlusOutlined} from "@ant-design/icons-vue";
import {session} from "@/model/session";


export default /*@__PURE__*/_defineComponent({
  __name: 'UploadView',
  props: {
    images: {},
    max: {},
    imageSizeLimit: {},
    title: {},
    showUploadButton: { type: Boolean }
  },
  emits: ['update:images', 'change'],
  setup(__props: any, { emit: __emit }) {


const props = __props
const emits = __emit

const info = reactive({
  fileList: [] as UploadFile[],
  preview: {visible: false, title: '', image: ''}
})

onMounted(() => {
  info.fileList = props.images.map(i => ({
        status: 'done', url: i,
        thumbUrl: i.endsWith('mp4') ? require('@/assets/image/mp4.png') : `${i}-sq.200`
      } as UploadFile)
  )
  watch(() => props.images, () => {
    info.fileList = props.images.map(i => {
      return {
        status: 'done',
        url: i,
        thumbUrl: i.endsWith('mp4') ? require('@/assets/image/mp4.png') : `${i}-sq.200`
      } as UploadFile
    })
  }, {deep: true})
})


const isImageUrl = (f: UploadFile): boolean => {
  return (f.thumbUrl?.endsWith('-sq.200') ?? true) || (f.thumbUrl?.startsWith('data:image') ?? true);
}

const onUploadChange = (j: Record<string, UploadFile>) => {
  const f = j.file
  console.log(f.status)
  if (f.status == 'done') {
    if (f.url?.endsWith('mp4')) f.thumbUrl = require('@/assets/image/mp4.png')
    else f.thumbUrl = f.url + '-sq.200'
    emits('update:images', info.fileList.map(i => i.url))
    emits('change', info.fileList.map(i => i.url))
  } else if (f.status == 'removed') {
    emits('update:images', info.fileList.map(i => i.url))
    emits('change', info.fileList.map(i => i.url))
  } else if (f.status == 'error') {
    message.error('上传失败')
  } else if (f.status == undefined) {
    info.fileList.pop()
  }
}

function getBase64(file: File) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

const handleCancel = () => {
  info.preview.visible = false;
  info.preview.title = '';
}

const handlePreview = async (file: UploadProps['fileList'][number]) => {
  if (!file.url && !file.preview) {
    file.preview = (await getBase64(file.originFileObj)) as string;
  }
  info.preview.image = file.url || file.preview;
  info.preview.visible = true;
  info.preview.title = '';
};


return (_ctx: any,_cache: any) => {
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_upload, _mergeProps({
      "file-list": info.fileList,
      "onUpdate:fileList": _cache[0] || (_cache[0] = ($event: any) => ((info.fileList) = $event)),
      "list-type": "picture-card",
      data: (f) => _unref(session).ossSign(f,1024*1024),
      accept: ".jpg,.jpeg,.png",
      "max-count": __props.max,
      action: "https://activity-guandb-cn.oss-cn-shanghai.aliyuncs.com",
      "show-upload-list": {showRemoveIcon:true,showDownloadIcon:false},
      "is-image-url": isImageUrl,
      onChange: onUploadChange,
      onPreview: handlePreview
    }, _ctx.$attrs), {
      default: _withCtx(() => [
        (info.fileList.length < __props.max || __props.showUploadButton)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_unref(PlusOutlined)),
              _createElementVNode("div", _hoisted_2, _toDisplayString(__props.title ?? '上传'), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 16, ["file-list", "data", "max-count"]),
    _createVNode(_component_a_modal, {
      open: info.preview.visible,
      "onUpdate:open": _cache[1] || (_cache[1] = ($event: any) => ((info.preview.visible) = $event)),
      title: info.preview.title,
      footer: null,
      onCancel: handleCancel
    }, {
      default: _withCtx(() => [
        (info.preview.image.split('.').pop() != 'mp4')
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              alt: info.preview.title,
              src: info.preview.image,
              style: {"width":"100%"}
            }, null, 8, _hoisted_3))
          : (_openBlock(), _createElementBlock("video", {
              key: 1,
              src: info.preview.image,
              controls: "",
              style: {"width":"100%"}
            }, null, 8, _hoisted_4))
      ]),
      _: 1
    }, 8, ["open", "title"])
  ], 64))
}
}

})